import { DEFAULT_OTP_LENGTH } from 'home/view/check-feasibility/unauth-view/constant';
import { DOCUMENT_TYPE_ENUM } from 'home/view/manage-feasibility/constants';

export const otpValidator = (value, otpLength = DEFAULT_OTP_LENGTH) => {
  let errors = [];

  // number validation
  errors = doValidationByRegex(/^(0|[1-9][0-9]*)$/, value, 'Please enter numeric values only');

  if (errors?.length) {
    return errors;
  }

  // otp length validation
  if (value?.length !== otpLength) {
    errors = ['Please enter valid 4 digit OTP code'];
  }

  return errors;
};

export const numberValidator = (value) => doValidationByRegex(/^(\s*|\d+)$/, value, 'Please enter only numeric characters');

export const priceValidator = (value) => {
  const MAX_ALLOWED_INT = 2147483647;

  if (value && parseInt(value) > MAX_ALLOWED_INT) {
    return ['Please enter a valid value'];
  }

  return doValidationByRegex(/^(\s*|\d+)$/, value, 'Please enter only numeric characters');
};

export const alphaNumbericValidator = (value) => doValidationByRegex(/^[0-9a-zA-Z]+$/, value, 'Please enter only alphanumeric characters');

export const alphaValidatorWithSpaces = (value) => doValidationByRegex(/^[a-zA-Z -_]+$/, value, 'Please enter only alphanumeric characters');

export const customCompanyValidator = (value) => {
  let errors = [];
  errors = doValidationByRegex(/^[a-zA-Z0-9-#&.]+(?: [a-zA-Z0-9-#&.]+)*$/, value, 'Please enter valid value');

  if (errors?.length) {
    return errors;
  }

  // length validation ({ minlength: 3, maxlength: 30})
  if (value?.length < 3 || value?.length > 30) {
    errors = ['Please enter valid value'];
    // errors = ['Please enter valid value [3-30 chars]'];
  }

  return errors;
};

export const customNameValidator = (value) => {
  let errors = [];
  errors = doValidationByRegex(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/, value, 'Please enter valid value');

  if (errors?.length) {
    return errors;
  }

  // length validation ({ minlength: 3, maxlength: 30})
  if (value?.length < 3 || value?.length > 30) {
    errors = ['Please enter valid value'];
    // errors = ['Please enter valid value [3-30 chars]'];
  }

  return errors;
};

export const alphaNumericValidatorWithSpecialCharacters = (value) =>
  doValidationByRegex(/^[a-zA-Z0-9!@#$-:&()\\-`.+,/\"]+(?: [a-zA-Z0-9!@#$-:&()\\-`.+,/\"]+)*$/, value, 'Please enter valid value');

export const salesCodeValidator = (value) => {
  let errors = [];
  errors = doValidationByRegex(/^[a-zA-Z0-9!@#$-:&()\\-`.+,/\"]+(?: [a-zA-Z0-9!@#$-:&()\\-`.+,/\"]+)*$/, value, 'Please enter valid value');

  if (errors?.length) {
    return errors;
  }

  // length validation ({ minlength: 3})
  if (value?.length < 3) {
    errors = ['Sales code should have atleast 3 characters'];
    // errors = ['Please enter valid value [3-30 chars]'];
  }

  return errors;
};

export const OlmIdValidator = (value) => {
  let errors = [];
  errors = doValidationByRegex(/[a-bA-B]{1}[0-9]{7}/, value, 'Please enter valid value');

  if (errors?.length) {
    return errors;
  }

  if (value?.length < 8) {
    errors = ['OLM ID should have atleast 8 characters'];
  }

  return errors;
};

export const pinCodeValidator = (value) => doValidationByRegex(/^[1-9][0-9]{5}$/, value, 'Please enter valid Pincode');

export const ipValidator = (value) =>
  doValidationByRegexForNonMandatoryFields(
    /^([01]?\d\d?|2[0-4]\d|25[0-5])(?:\.[01]?\d\d?|\.2[0-4]\d|\.25[0-5]){3}(?:\/[0-9]?\d|\/[0-9])?$/,
    value,
    'Please enter valid IP address'
  );

export const mandatoryFieldValditor = (value) => {
  const errors = [];
  if (value === null || value.trim().length === 0) {
    errors.push('This is a mandatory field');
  }
  return errors;
};

// export const gstinValidator = (value) => /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/.test(value);
export const gstinValidator = (value) => {
  if (!value) return false;
  return value.trim().length >= 15;
};

export const panValidator = (value) => /[A-Z]{5}[0-9]{4}[A-Z]{1}/.test(value);
export const pincodeValidator = (value) => /^[1-9][0-9]{5}$/.test(value);
export const addressValidator = (value) => /^$|([A-Za-z0-9 &:)(.#@_',\-\/^])+$/.test(value);

export const mobileValidator = (value) => doValidationByRegex(/^[6-9]{1}[0-9]{9}$/, value, 'Please enter valid mobile number');

export const emailValidaotr = (email) => doValidationByRegex(/^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[\w-]+(\.[\w-]+)*(\.[\w-]{2,})$/, email, 'Please enter valid email');

const doValidationByRegex = (regex, value, error) => {
  const errors = [];
  if (value === null || value.length === 0) {
    errors.push('This is a mandatory field');
  } else if (regex && !regex.test(value)) {
    errors.push(error);
  }
  return errors;
};

// For optional/ non-mandatory fields, when form value is empty errors (Array) should be empty ([]) too.
const doValidationByRegexForNonMandatoryFields = (regex, value, error) => {
  let errors = [];
  if (value === null || value.length === 0 || !value) {
    errors = [];
  } else if (regex && !regex.test(value)) {
    errors.push(error);
  }
  return errors;
};

export const isFormValid = (form, keyToIgnore, optionalKeys = []) => {
  if (typeof form === 'object' && form !== null) {
    return Object.entries(form).every(([key, value]) => {
      // For optional/ non-mandatory fields, return form validity as true when form value is empty else continue error checking.
      if (Array.isArray(optionalKeys) && optionalKeys.length > 0 && optionalKeys.includes(key) && !value['value']) {
        return true;
      } else if (key === 'errors' && Array.isArray(value) && value.length > 0) {
        return false;
      } else if (Array.isArray(keyToIgnore) && (keyToIgnore.includes(key) || key === 'touched')) {
        return true;
      } else if (typeof value === 'object' && value !== null) {
        return isFormValid(form[key], keyToIgnore);
      }
      return !!value;
    });
  }
};

const sortedKeyList = (arr, documentType) => {
  let sortedArray = [];

  switch (documentType) {
    case DOCUMENT_TYPE_ENUM.PURCHASE_ORDER: {
      sortedArray = arr.sort((a, b) => {
        const firstItemIndex = a.split('').reverse().join('').split('_')[0] || '';
        const modifiedFirstIndex = firstItemIndex.length === 1 ? parseInt(firstItemIndex) : 0;
        const secondItemIndex = b.split('').reverse().join('').split('_')[0] || '';
        const modifiedSecondIndex = secondItemIndex.length === 1 ? parseInt(secondItemIndex) : 0;

        return modifiedFirstIndex - modifiedSecondIndex;
      });

      break;
    }

    default: {
      sortedArray = [...arr];
    }
  }

  return sortedArray;
};

export const validateFileAndGetFormData = ({ event, supportedTypes, maxFileLimit, documentNames, documentType, allowMultiplePDFs = false, files = [] }) => {
  //maxFileLimit is in kb
  event.stopPropagation();
  let isFilesValid = true;
  let errorMessage = '';
  const filesMetaData = [];
  const { files: selectedFiles } = event.target;
  const formData = new FormData();
  const fileList = Array.from(selectedFiles);

  const schemaKeyList = documentNames;

  let activeKeyList = [];
  const uploadedKeyList = [];

  files.forEach((item) => {
    uploadedKeyList.push(item.documentName);
  });

  const filteredActiveKeyList = schemaKeyList.filter((item) => !uploadedKeyList.includes(item));

  if (filteredActiveKeyList.length > 0) {
    activeKeyList = sortedKeyList(filteredActiveKeyList, documentType);
  }

  fileList.forEach((file, index) => {
    const { type, size, name } = file;

    if (fileList.length > activeKeyList.length) {
      errorMessage = `Maximum ${documentNames.length} files are allowed in multiple upload`;
      isFilesValid = false;
    }

    if (!(Array.isArray(supportedTypes) && supportedTypes.includes(type))) {
      errorMessage = `Invalid file format. Try to re-upload the correct format`;
      isFilesValid = false;
    } else if (!allowMultiplePDFs && type === 'application/pdf' && fileList.length > 1) {
      errorMessage = 'Only single upload is allowed in case of pdf file';
      isFilesValid = false;
    } else if (!(size <= maxFileLimit)) {
      errorMessage = `Maximum file size is ${maxFileLimit / 1024 / 1024} Mb`;
      isFilesValid = false;
    }
    formData.append(`documents['${activeKeyList[index]}']`, file);
    filesMetaData.push({ name, size, type, documentName: activeKeyList[index] });
  });
  formData.append('documentType', documentType);

  return { isFilesValid, formData, filesMetaData, errorMessage };
};

export const isResponseValid = ({ data }) => data && Object.hasOwnProperty('result') && Object.keys(data.result).length > 0;

export const isFunction = (value) => value && (Object.prototype.toString.call(value) === '[object Function]' || 'function' === typeof value || value instanceof Function);

export const isKAMUser = (user) => {
  return user === 'KAM' || window.location.pathname.includes('rate-card');
};
